import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { EntTypeTransport } from "../../../models/handBooks/typeTransport";
import { EntTypeTransportFilter } from "../../../models/filters/typeTransportFilter";
import { Paths } from "../../../paths";

export const transportTypesApi = agroApi.injectEndpoints({
    endpoints: (builder) => ({
        getTransportTypeList: builder.query<ResponseDataGet<EntTypeTransport>, EntTypeTransportFilter>({
            query: (filter) => ({
                url: `${Paths.handbooks.typetransport}/get-all`,
                method: "POST",
                body: JSON.stringify(filter)
            }),
        }),
        getTransportTypeById: builder.query<ResponseDataTest<EntTypeTransport>, number>({
            query: (id) => ({
                url: `${Paths.handbooks.typetransport}/${id}`,
                method: 'GET'
            })
        }),
        addTransportType: builder.mutation<ResponseDataTest<EntTypeTransport>, EntTypeTransport>({
            query: (body) => ({
                url: `${Paths.handbooks.typetransport}`,
                method: "POST",
                body: JSON.stringify(body)
            }),
        }),
        editTransportType: builder.mutation<ResponseDataTest<EntTypeTransport>, EntTypeTransport>({
            query: (body, ) => ({
                url: `${Paths.handbooks.typetransport}`,
                method: 'PUT',
                body: JSON.stringify(body),
            }),
        }),
        deleteTransportType: builder.mutation<ResponseDataTest<EntTypeTransport>, number>({
            query: (id) => ({
                url: `${Paths.handbooks.typetransport}/${id}`,
                method: 'DELETE',
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useAddTransportTypeMutation,
    useDeleteTransportTypeMutation,
    useEditTransportTypeMutation,
    useLazyGetTransportTypeListQuery
} = transportTypesApi;
